/* eslint-disable camelcase */
import myZoneServiceProvider from '@/api/serviceProviders/my-zone'
import { ExtendedApiResponse } from '@/types/general/ResponseType'
import { LoginUserResponse } from '@/api/requests/authentication/authenticationResponses'
import { WebAuthnCredentialPayload } from '@/utils/webauthn'

export type PasskeyOptionsResponse = ExtendedApiResponse<{
    challenge_id: string
    options: PublicKeyCredentialCreationOptions | PublicKeyCredentialRequestOptions
}>

export type Passkey = {
    id: number | string
    name?: string | null
    created_at?: string | null
    updated_at?: string | null
    last_used_at?: string | null
}

export type PasskeysResponse = ExtendedApiResponse<Passkey[]>

export const getPasskeyLoginOptions = async (recaptcha?: string) => {
    return await myZoneServiceProvider.post('auth/login/passkeys/options', {
        recaptcha,
    }) as PasskeyOptionsResponse
}

export const loginUserWithPasskey = async (
    challengeId: string,
    passkey: WebAuthnCredentialPayload
) => {
    return await myZoneServiceProvider.post('auth/login/passkeys', {
        challenge_id: challengeId,
        passkey,
    }) as LoginUserResponse
}

export const getPasskeys = async () => {
    return await myZoneServiceProvider.get('auth/passkeys') as PasskeysResponse
}

export const getPasskeyRegistrationOptions = async () => {
    return await myZoneServiceProvider.post('auth/passkeys/options') as PasskeyOptionsResponse
}

export const createPasskey = async (
    challengeId: string,
    passkey: WebAuthnCredentialPayload,
    name?: string
) => {
    return await myZoneServiceProvider.post('auth/passkeys', {
        challenge_id: challengeId,
        passkey,
        name,
    }) as ExtendedApiResponse<Passkey>
}

export const updatePasskey = async (id: number | string, name: string) => {
    return await myZoneServiceProvider.put(`auth/passkeys/${id}`, {
        name,
    }) as ExtendedApiResponse<Passkey>
}

export const deletePasskey = async (id: number | string) => {
    return await myZoneServiceProvider.delete(`auth/passkeys/${id}`) as ExtendedApiResponse<null>
}
